/* eslint-disable react/prop-types */
import React from 'react';

import ReactBootstrapModal from 'react-bootstrap/Modal';
import ArrowIcon from '../../../../../../../../assets/icons/act-to.svg';
import ProfileIcon from '../../../../../../../../assets/icons/profile.svg';
import RevokeIcon from '../../../../../../../../assets/icons/revoke-big.svg';
import CloseModal from '../../../../../../../../assets/icons/close-modal.svg';
import {showToast} from '../../../../../../../../components/common/Toast';

import {RevokeStudentModalContainer} from './elements';

export const RevokeStudentModal = ({
  onClose,
  revokeCallback,
  studentName,
  isVisible,
}) => (
  <ReactBootstrapModal centered onHide={() => {}} show={isVisible}>
    <RevokeStudentModalContainer className="revoke-modal">
      <div className="revoke-modal-custom-full">
        <div className="close-btn-revoke">
          <button
            onClick={onClose}
            type="button"
            className="revoke-modal-close"
          >
            <img alt="Close" src={CloseModal} />
          </button>
        </div>
        <div className="revoke-student-modal-wrapper">
          <div className="graphics">
            <img alt="Revoke Student" src={RevokeIcon} />
            <img alt="To" src={ArrowIcon} className="to-arrow" />
            <img alt={studentName} src={ProfileIcon} />
          </div>
          <h2>Do you want to revoke {studentName} from this</h2>
          <h2>assessment?</h2>
          <p>By revoking a student, the student will be removed from the</p>
          <p>assessment. Do you want to continue?</p>
          <button
            className="send-button"
            onClick={() => {
              showToast(
                false,
                `${studentName} Has been revoked successfully`,
                true,
              );
              revokeCallback();
              onClose();
            }}
            type="button"
          >
            Revoke Student
          </button>
          <button className="cancel-button" onClick={onClose} type="button">
            No, Cancel
          </button>
        </div>
      </div>
    </RevokeStudentModalContainer>
  </ReactBootstrapModal>
);
